import styles from "./OnboardingStyles.module.css";
import PrimaryButton from "../Button/PrimaryButton/PrimaryButton";
import { StepFormProps } from "../../types/onboarding.types";
import { useOrderContext } from "../../context/OrderContext";
import { useTranslation } from "react-i18next";
import { useCartContext } from "../../context/CartContext";
import { normalizeDate, filterDatesOnOrAfterEffectiveTomorrow } from "../../utils/calendar";
import OnboardingRecap from "./OnboardingRecap";

const Step9Form = ({ currentStep, setStep, formData }: StepFormProps) => {
    const { t } = useTranslation();
    const { orderData } = useOrderContext();
    const { cartData } = useCartContext();

    const cartDatesISO = filterDatesOnOrAfterEffectiveTomorrow(
        (cartData?.selected_dates ?? []).map(normalizeDate)
    );

    const handleAction = () => {
        setStep(currentStep + 1);
    };

    return (
        <>
        <div className={styles.OnboardingContent}>
            <div className={styles.Container}>
            <div className={styles.SecondaryTitle}>
                <p>{t("onboarding.steps.9.title")}</p>
            </div>
            <OnboardingRecap
                formData={formData}
                cartDatesISO={cartDatesISO}
                address={orderData.address}
            />

            <div className={styles.FinishButton}>
                <PrimaryButton onClick={() => handleAction()} text={t("buttons.proceed")} />
            </div>
            </div>
        </div>
        </>
    );
};

export default Step9Form;
